module.exports = __webpack_public_path__ + "static/media/hashtag.1c5ded58.svg";